<template>
  <div>
    <h1>Historial de activación de alertas de pánico del Pasajero</h1>
    <b-row>
      <b-col md="6" class="my-1">
        <b-form-group label-cols-sm="3" label="Buscar" class="mb-0">
          <b-input-group>
            <b-form-input v-model="filter" class="form-control" placeholder="Buscar alerta"></b-form-input>
            <b-input-group-append>
              <b-button :disabled="!filter" @click="filter = ''">Limpiar</b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col md="6" class="my-1">
        <b-form-group label-cols-sm="3" label="Registros por página" class="mb-0">
          <b-form-select v-model="perPage" :options="pageOptions" class="form-control"></b-form-select>
        </b-form-group>
      </b-col>
    </b-row>
    <b-table
      show-empty
      stacked="md"
      :items="getEmergencyHistory"
      :fields="fields"
      :current-page="currentPage"
      :per-page="perPage"
      :filter="filter"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      :sort-direction="sortDirection"
      @filtered="onFiltered"
      empty-text="No existen registros por mostrar"
      emptyFilteredText="No existen registros por mostrar"
    >
      <template v-slot:cell(acciones)="row">
        <b-button size="sm" @click="toggleDetails(row)" class="mr-2">
          {{ row.detailsShowing ? 'Cerrar' : 'Ver'}} detalles
        </b-button>
      </template>
      <template v-slot:cell(apaternoUsuario)="row">
          {{ row.item. apaternoUsuario +' '+ row.item. amaternoUsuario }}
      </template>
      <template #row-details="row">
        <b-table
          :items="row.item.detail"
          small
          borderless
          :fields="[{ key: 'lugar', label: 'Lugar última ubicación' }, { key: 'hora', label: 'Hora' }, { key: 'fecha', label: 'Fecha' }]"
          >
        </b-table>
      </template>
    <!--
      <template v-slot:cell(acciones)="row">-->
        <!--<router-link size="sm" :to="{name:'postDrivers', params:{id:row.item.id}}" class="mr-1"><b-button class="btn-sm" variant="outline-warning">Editar</b-button></router-link>-->
        <!--<router-link size="sm" :to="{name:'postDrivers', params:{id:row.item.id}}" class="mr-1"><b-button class="btn-sm" variant="outline-danger">Eliminar</b-button></router-link>-->
        <!--<b-button class="btn-sm" variant="outline-warning"  @click="validateCheckIn(row.item)">Editar</b-button>-->
        <!--<b-button class="btn-sm" variant="outline-warning"  @click="$router.push({ name: 'updateDriver', params: row.item })">update</b-button>-->
     <!--</template>-->
    </b-table>
    <b-row>
      <b-col md="6" class="my-1">
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          class="my-0"
        ></b-pagination>
      </b-col>
    </b-row>
    <div class="text-center" v-if="$apollo.queries.getEmergencyHistory.loading">
      <b-spinner variant="danger" label="Spinning">Cargando</b-spinner>
    </div>
  </div>
</template>
<script>
import gql from 'graphql-tag'
import axios from 'axios'
import config from '../../../../environment.json'
import headers from '@/config/headers.js'
const GET_DRIVERS_EMERGENCIES = gql`
  query getEmergencyHistory($appSolicitud: String){
    getEmergencyHistory(appSolicitud: $appSolicitud){
      pk
      sk
      telefono
      nombreUsuario
      apaternoUsuario
      amaternoUsuario
      placa
      niv
      descripcionVehiculo
      marca
      modelo
      direccion
      municipio
      estado
      latitud
      longitud
      idTipoEmergencia
      appSolicitud
      folio
    }
  }
`
const GET_EMERGENCY_DETAIL = gql`
  query getDetailsEmergency($sk: String){
    getDetailsEmergency(sk: $sk){
      latitud
      status
      hora
      fecha
      longitud
    }
  }
`
export default {
  data() {
    return {
      getEmergencyHistory: [],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [5, 10, 15],
      sortBy: null,
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      fields: [
        { key: 'sk', label: 'Número de folio de emergencia' },
        { key: 'placa', label: 'Placa del vehículo' },
        { key: 'nombreUsuario', label: 'Nombre(s) del pasajero' },
        { key: 'apaternoUsuario', label: 'Apellidos del pasajero' },
        { key: 'estado', label: 'Estado' },
        'acciones',
      ],
    }
  },
  apollo: {
    getEmergencyHistory: {
      query: GET_DRIVERS_EMERGENCIES,
      variables() {
        return {
          appSolicitud: 'Pasajero',
        }
      },
      context: headers(),
      result({ data }) {
        if (data.getEmergencyHistory != null) {
          this.totalRows = data.getEmergencyHistory.length
        }
      },
      error(err) {
        console.log(err)
      },
    },
  },
  methods: {
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    toggleDetails(row) {
      if (!row.item.detail) {
        this.$apollo.query({
          query: GET_EMERGENCY_DETAIL,
          variables: {
            sk: row.item.sk,
          },
          context: headers(),
        })
          .then(({ data }) => {
            if (data.getDetailsEmergency.length) {
              const lat = data.getDetailsEmergency[0].latitud
              const lng = data.getDetailsEmergency[0].longitud
              const mapKey = config[process.env.NODE_ENV].mapKey
              axios.get(`https://maps.googleapis.com/maps/api/geocode/json?address=${lat},${lng}&key=${mapKey}`)
                .then(result => {
                  console.log(result)
                  row.item.detail = data.getDetailsEmergency
                  row.item.detail[0].lugar = result.data.results[0].formatted_address
                  row.toggleDetails()
                })
                .catch(error => {
                  console.log(error)
                })
            } else {
              // console.log(row)
              row.item.detail = [{ lugar: null }]
              row.item.detail[0].lugar = row.item.direccion
              // console.log(row.item.detail)
              row.toggleDetails()
            }
          })
          .catch(err => {
            console.log(err)
          })
      } else {
        row.toggleDetails()
      }
    },
  },
}
</script>
